<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
            <b-button size="sm"
              @click="goMainLogin()"
              style="border:none;margin:0;padding:0.1rem 0.5rem;text-transform:uppercase;text-decoration:underline;font-size:0.7rem;"
              variant="outline-secondary">
              Return to Main Login Page
            </b-button>
        </b-col>
      </b-row>
      <b-row align-h="center">
        <b-col md="6">
          <b-card v-if="ready">
            <b-card-text class="text-center" v-if="logo">
               <img style="max-width:100%" :src="logo">
               </img>
            </b-card-text>
            <div class="mb-2" style="text-align:center;font-weight:bold;">
              Enter as a Guest
            </div>
            <b-card-text>
               <input-sub ref="in_name"
                 class="mb-2"
                 v-model="name"
                 maxlength=32
                 v-on:enter="checksubmit"
                 placeholder="Your Name (required)">
               </input-sub>
               <input-sub ref="in_email"
                 class="mb-2"
                 v-model="email"
                 maxlength=48
                 v-on:enter="checksubmit"
                 placeholder="person@site.com (required)">
               </input-sub>
               <auto-text-area size="sm" v-if="questShow"
                 style="font-size:0.8rem"
                 v-model.trim="question"
                 maxlength="150"
                 :placeholder="questPrompt">
               </auto-text-area>
               <b-input  v-if="false"
                 class="mb-2"
                 v-model="key"
                 maxlength=12
                 placeholder="The numbers shown below">
               </b-input>
               <b-button size="sm" class="mb-2"
                 v-if="!login_inprogress"
                 :disabled="!valid_input()"
                 variant="primary"
                 @click="guest_login"
               >
                 Enter
               </b-button>
               <b-button size="sm" class="mb-2"
                 v-if="login_inprogress"
                 variant="secondary"
               >
                 Logging in...
               </b-button>
               <b-button v-if="false"
                 size="sm" class="float-right"
                 variant="secondary"
                 @click="init"
               >
                 Refresh
               </b-button>
            </b-card-text>
            <div v-if="error"
              style="font-size: 0.8rem; color:red"
            >
              {{ error }}
            </div>
          </b-card>
        </b-col>
      </b-row>
      <b-row v-show="false" align-h="center">
        <b-col md="6" style="text-align:center">
          <canvas ref="outcanvas" class="dotnum"
            width="384" height="64"
            style="">
          </canvas>
        </b-col>
      </b-row>
    <!--
      <canvas ref="mycanvas"
       width="64" height="64"
       style="width: 200px;height: 200px;border: solid 2px black;">
      </canvas>
    -->
    </b-container>
  </div>
</template>

<script>
import { sync } from "vuex-pathify";
import store from "../store";
import vx_api from "../vuemix";
import InputSub from "../components/InputSub";
import AutoTextArea from "../components/AutoTextArea";

export default {
  name: "bounce",
  data() {
    return {
      ready: false,
      error: "",      
      name: "",
      email: "",
      key: "1",
      logo: "",
      questShow: false,
      questPrompt: "Optional question or reason for visiting",
      question: "",
      login_inprogress: false,
    }
  },
  components: {
    InputSub,
    AutoTextArea,
  },
  created() {
  },
  mounted() {
    let vue = this;
    vue.init();
    if ((vue.can = vue.$refs.mycanvas)) {
      vue.can.addEventListener('click', vue.canclick);
      vue.list = [];
    }
    vxslog({p:"guest",a:"open"});
    vue.accountAPI();

    let gdata = getLocal("guest",true);
    if (gdata) {
       if (gdata.name) { vue.name = gdata.name; }
       if (gdata.em) { vue.email = gdata.em; }
    }

    let fwd = getLocal("vx_page_href");
    let m;
    if (fwd && ((m=fwd.match(/room\/[\w\-]+\/([\w\-\:]+)/)) ||
                (m=fwd.match(/chat\/[\w\-]+\/([\w\-\:]+)/))) ) {
      if (m[1]) {
        let url = (vx.rq_endpoint+"/room/"+m[1]+
                    "/pub/guest?acc="+vx.acc);
        issue_http({nocred:true, type:"GET", url: url, done: function(s,r) {
            let j = to_json(r);
            if (j && j.ok && j.gqcfg) {
              vue.questShow = !!j.gqcfg.en;
              if (j.gqcfg.prompt) {
                vue.questPrompt = j.gqcfg.prompt;
              }
            }
          }
        });
      } //match
    } //fwd
  },
  beforeDestroy() {
    let vue = this;
    if (vue.can) {
      vue.can.removeEventListener('click', vue.canclick);
    }
  },
  methods: {
    init: function() {
      let vue = this;
      let url = "//"+vx.subd+".vuemix.com/api/v2/users/guest";
      let can = vue.$refs.outcanvas;
      let ctx = can.getContext('2d');
      ctx.clearRect(0,0,384,64);
      vue.error = "";

      clearTimeout(vue.tid);
      vue.tid = setTimeout(function() {
        issue_http({type:"GET", url: url, done: function(s,r) {
         if (s != 200) {
           vue.error = "Unable to sign in as guest at this time";
           return;
         }
         let j = to_json(r);
         if (!j || j.status != 200) {
           vue.error = "Unable to sign in as guest at this time";
           return;
         }
         // Use anything from j as needed
         if (j.state && j.state.dots) {
           let bx = 0;
           console.log("draw");
           j.state.dots.forEach(function(dot) {
             ctx.fillStyle = "#000060";
             ctx.fillRect(bx+dot[0]-2, dot[1]-2, 5, 5);
           });
           vue.gu = j.state.gu;
         }
         vue.ready = true;
        }
        });
      }, 1000);
    },
    valid_input: function() {
      let vue = this;
      if (!vue.name || vue.name.length < 2) {
        return false;
      }
      if (!vue.email || !window.validate_email(""+vue.email)) {
        return false;
      }
      //if(!vue.key) {
      //  return false;
      //}
      return true;
    },
    guest_login: function() {
      let vue = this;
      let url = "//"+vx.subd+".vuemix.com/api/v2/users/guest";
      let gdata = {};
      vue.error = "";
      vue.login_inprogress = true;
      gdata.em = vue.email;
      gdata.name = vue.name;
      gdata.key = vue.key;
      gdata.gu = vue.gu;
      if (!window.validate_email(gdata.em)) {
        vue.error = "The email appears to be invalid";
        return;
      }
      issue_http({type:"POST", url: url,
        contentType: "application/json",
        data: JSON.stringify(gdata),
        done: function(s,r2) {
           eraseLocal("guest");
           if (s != 200) {
             vue.error = "Your attempt to sign in as a guest failed.";
             vxslog({p:"guest",a:"fail"});
             vue.login_inprogress = false;
             return;
           }
           let j2 = to_json(r2);
           //console.log(j2.status, j2.message);
           if (j2.status != 200) {
             vue.error = "Error:"+(j2.message || "submission failed.");
             vxslog({p:"guest",a:"fail"});
             vue.login_inprogress = false;
             return;
           }
           let guid = j2.state.guid;
           let cred = j2.state.creds.me;
           vxslog({p:"guest",a:"succ"});
           vx_api.getSelf(window.vx,cred).then(self_res => {
              vue.login_inprogress = false;
              delete gdata.gu;
              setLocal("guest",JSON.stringify(gdata));
              setLocal("vx_cred_me",cred);
              vue.$user.set(Object.assign({
                 role: "authenticatedUser"
              },
              self_res));
              if (!getLocal("vx_page_href")) {
                setLocal("vx_page_href","_default");
              }
              if (vue.questShow && (""+vue.question)) {
                /* Continuing on to a room */
                window.vx.guestQuestion = ""+vue.question;
                vue.$parent.leaveMsgText = ""+vue.question;
                vue.question = "";
              }
              continue_to_page(vue.$router);
           });
        }
      });
    },
    canclick: function(ev) {
      let vue = this;
      let rect = vue.can.getBoundingClientRect();
      let x = Math.round(64 * (ev.clientX - rect.left)/rect.width);
      let y = Math.round(64 * (ev.clientY - rect.top)/rect.height);
      console.log("cancl",x,y);
      let ctx = vue.can.getContext("2d");
      if (x < 5 && y < 5) {
         ctx.clearRect(0,0,64,64);
         console.log(JSON.stringify(vue.list));
         vue.list = [];
      } else {
        ctx.fillStyle = "#000000";
        ctx.fillRect(x-1, y-1, 2, 2);
        vue.list.push([x,y]);
        console.log("cnt",vue.list.length);
      }
    },
    accountAPI: function() {
      let vue = this;
      let url = vx.rq_endpoint+"/adm/account/kp/"+vx.subd+"/cfg";
      issue_http({nocred:true, type:"GET", url: url, done: function(s,r) {
         if (s == 200) {
           let j = to_json(r);
           vue.logo = j.logo;
         } else {
         }
      }});
    },
    goMainLogin: function() {
      /* Unless in the future we choose to use the existance of the 'guest'
       *   to automatically transition to guest login, keep values forever */
      //eraseLocal("guest");
      this.$router.push({ name: 'login' });
    },
    checksubmit: function() {
      let vue = this;
      console.log("submitted");
      if (!vue.valid_input()) { return; }
      if (vue.questShow && !vue.question) { return; }
      vue.guest_login();
    },
  }, //methods
  computed: {
  },
};
</script>

<style lang="scss" scoped>

.dotnum {
  width: 240px;
  height: 40px;
  border: solid 2px black;
}

@media screen and (max-width:600px) and (orientation:portrait) {
  .dotnum {
    width:  90vw;
    height: 15vw;
  }
}

</style>
